import { useState } from 'react';

import { GridColDef } from '@mui/x-data-grid';

import { translatePrefix } from '../';
import { OpShow } from '../../../../assets/icons';
import { DialogInOne, OpIconButton } from '../../../../components';
import { COLUMN_WIDTH } from '../../../../constants/ColumnWidth';
import { usePermission, useTranslation } from '../../../../hooks';
import { useGenGridCol } from '../../../../utils/ComponentHelper';
import { TableColumnKey } from '../types/Table';
import Permissions from '../../../../constants/Permissions';
import { useAppSelector } from '../../../../reducer/hooks';
import { selectIsMobileView } from '../../../../reducer/mediaSlice';

const useTableColumns = ({
  renderOperationCell,
  renderApprovalProgressCell,
}: {
  renderOperationCell: (params: any) => JSX.Element;
  renderApprovalProgressCell: (params: any) => JSX.Element;
}): GridColDef[] => {
  const { t } = useTranslation(translatePrefix);
  const { hasPermission } = usePermission();

  const isMobile = useAppSelector(selectIsMobileView);

  // const [showTransactionOperationsDialog, setShowTransactionOperationsDialog] = useState(false);
  // const renderTransactionOperationCell = (params: any) => {
  //   return (
  //     <>
  //       <OpIconButton
  //         title={''}
  //         svgUrl={OpShow}
  //         onClick={() => {
  //           setShowTransactionOperationsDialog(true);
  //         }}
  //       />

  //       <DialogInOne
  //         title={t(TableColumnKey.TRANSACTION_OPERATIONS)}
  //         self={{
  //           open: showTransactionOperationsDialog,
  //           onClose: () => setShowTransactionOperationsDialog(false),
  //         }}
  //         content={
  //           <>
  //             <div
  //               style={{
  //                 whiteSpace: 'pre-wrap',
  //                 lineHeight: '1.5',
  //                 fontFamily: 'monospace',
  //                 fontSize: '16px',
  //                 padding: '10px',
  //                 overflow: 'auto',
  //                 maxHeight: '60vh',
  //               }}
  //             >
  //               {JSON.stringify(params.row.rawData.transactionOperations, null, 2)}
  //             </div>
  //           </>
  //         }
  //         isConfirmHidden={true}
  //         onConfirm={() => {}}
  //         onCancel={() => setShowTransactionOperationsDialog(false)}
  //       />
  //     </>
  //   );
  // };

  const columns = [
    useGenGridCol('operation', {
      renderCell: renderOperationCell,
    }),
    // useGenGridCol(TableColumnKey.ID, {
    //   minWidth: 80,
    //   headerName: t(TableColumnKey.ID),
    // }),
    useGenGridCol(TableColumnKey.MERCHANT_NAME, {
      minWidth: isMobile ? 100 : COLUMN_WIDTH.MerchantId.MaxWidth,
      headerName: t(TableColumnKey.MERCHANT_NAME),
    }),
    useGenGridCol(TableColumnKey.BATCH_ID, {
      minWidth: isMobile ? 80 : 100,
      headerName: t(TableColumnKey.BATCH_ID),
    }),
    // useGenGridCol(TableColumnKey.APPROVAL_PROGRESS, {
    //   renderCell: renderApprovalProgressCell,
    //   minWidth: isMobile ? 110 : 120,
    // }),

    useGenGridCol(TableColumnKey.OPERATION_TYPE, {
      minWidth: isMobile ? 100 : 150,
      headerName: t(TableColumnKey.OPERATION_TYPE),
    }),

    useGenGridCol(TableColumnKey.CHAIN_NAME, {
      minWidth: 100,
      headerName: t(TableColumnKey.CHAIN_NAME),
    }),
    useGenGridCol(TableColumnKey.ASSET_NAME, {
      minWidth: 100,
      headerName: t(TableColumnKey.ASSET_NAME),
    }),
    useGenGridCol(TableColumnKey.TOTAL_OPERATION, {
      minWidth: isMobile ? 95 : 150,
      headerName: t(TableColumnKey.TOTAL_OPERATION),
    }),
    // useGenGridCol(TableColumnKey.REQUEST_TIME, {
    //   minWidth: COLUMN_WIDTH.CreatedDate.MinWidth,
    //   headerName: `${t(TableColumnKey.REQUEST_TIME)}`,
    // }),
    useGenGridCol(TableColumnKey.STATUS, {
      minWidth: isMobile ? 100 : 120,
      headerName: t(TableColumnKey.STATUS),
    }),
    useGenGridCol(TableColumnKey.RESULT, {
      minWidth: isMobile ? 80 : 100,
      headerName: t(TableColumnKey.RESULT),
    }),
    useGenGridCol(TableColumnKey.SIGNER_ADDRESS, {
      minWidth: 280,
      headerName: t(TableColumnKey.SIGNER_ADDRESS),
    }),
    // useGenGridCol(TableColumnKey.TRANSACTION_OPERATIONS, {
    //   minWidth: 150,
    //   headerName: t(TableColumnKey.TRANSACTION_OPERATIONS),
    //   renderCell: renderTransactionOperationCell,
    // }),

    // useGenGridCol(TableColumnKey.CREATED_BY, {
    //   minWidth: isMobile ? 100 : 150,
    //   headerName: t(TableColumnKey.CREATED_BY),
    // }),
    // useGenGridCol(TableColumnKey.CREATED_DATE, {
    //   minWidth: COLUMN_WIDTH.CreatedDate.MinWidth,
    //   headerName: `${t(TableColumnKey.CREATED_DATE)}`,
    // }),
    useGenGridCol(TableColumnKey.LAST_MODIFIED_BY, {
      minWidth: COLUMN_WIDTH.LastModifiedBy.MinWidth,
      headerName: t(TableColumnKey.LAST_MODIFIED_BY),
    }),
    useGenGridCol(TableColumnKey.LAST_MODIFIED_DATE, {
      minWidth: COLUMN_WIDTH.LastModifiedDate.MinWidth,
      headerName: `${t(TableColumnKey.LAST_MODIFIED_DATE)}`,
    }),
  ];

  return columns;
};

export default useTableColumns;
